import request from '@/utils/request'
import host from '@/api/base/host'

const v1 = host.path('dev', { dev: 'v1' })

export const imageTokenH5 = (data) => {
  return request({
    url: v1('subVipExamine/imageToken'),
    method: 'get',
    data
  })
}
// 校验家庭卡手机号
export const checkByDestMobile = (data) => {
  return request({
    url: v1('subVipExamine/checkByDestMobile'),
    method: 'post',
    data
  })
}

// 校验验证码
export const checkH5VerificationCodeOnly = (data) => {
  return request({
    url: v1('login/h5/checkH5VerificationCodeOnly'),
    method: 'post',
    data
  })
}
// 获取家庭卡申请记录
export const subVipExamineList = (data) => {
  return request({
    url: v1('subVipExamine/list'),
    method: 'post',
    data
  })
}

// 家庭卡审核详细
export const subVipExamineInfo = (data) => {
  return request({
    url: v1('subVipExamine/detail/id'),
    method: 'post',
    data
  })
}

// 更新家庭卡申请内容
export const subVipExamineUpdate = (data) => {
  return request({
    url: v1('subVipExamine/update'),
    method: 'post',
    data
  })
}